module.exports = __webpack_public_path__ + "img/public/SiteIcons/textCopyIcon.svg?fb8cc550";